/* fyi your booking link is in cloudflare > rules */
export const BOOKING_LINK = "https://book.hoshinomedia.com/";
